import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntil } from 'rxjs';
import { TuiEditor, TuiEditorTool } from '@taiga-ui/editor';
import { BaseComponent } from '@src/app/modules/base';
import { EnvService } from '@src/app/modules/env';

@Component({
  selector: 'message-input',
  templateUrl: './message-input.component.html',
  styleUrls: ['./message-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageInputComponent extends BaseComponent implements OnInit {
  private readonly env = inject(EnvService);

  @Input() set message(text: string) {
    this.control.patchValue(text);
  }
  @Output() messageChange = new EventEmitter<string>();

  @Input() invalid = false;
  @Input() floatingToolbar = false;
  @Input() placeholder = '';

  @Output() onEnterKeyPressed = new EventEmitter<void>();

  protected readonly control = new FormControl();

  protected readonly toolbarTools = [
    TuiEditorTool.Undo,
    TuiEditorTool.Italic,
    TuiEditorTool.Strikethrough,
    TuiEditorTool.Underline,
    TuiEditorTool.Bold,
    TuiEditorTool.Link,
  ];

  ngOnInit(): void {
    this.control.valueChanges.pipe(takeUntil(this.destroyed$$)).subscribe(value => this.messageChange.emit(value));
  }

  keydown(event: KeyboardEvent, target: TuiEditor) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.stopPropagation();
      event.preventDefault();

      if (this.env.isMobilePlatform) {
        const event = new KeyboardEvent('keydown', {
          key: 'Enter',
          shiftKey: true,
          bubbles: true,
          cancelable: true,
        });
        target.nativeFocusableElement?.dispatchEvent(event);
      } else {
        this.onEnterKeyPressed.emit();
      }

      return;
    }
  }
}
